import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectWorldCupResult, simWorldCupResultAsync } from './features/WorldCupResultSlice';
import { useRef } from 'react';
import { fetchTeamsAsync, selectTeam } from './features/TeamSlice';
import { Accordion, AccordionDetails, AccordionSummary, Backdrop, CircularProgress, Link, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import WorldCupGroupStage from './features/WorldCupGroupStage';
import WorldCupBracket from './features/WorldCupBracket';
import KnockOutStage from './features/KnockOutStage';
import SimWorldCupHeader from './features/SimWorldCupHeader';
import Footer from './features/Footer';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
})

function SimWorldCupApp() {

  const dispatch = useDispatch();
  const dataFetchedRef = useRef(false);
  const result = useSelector(selectWorldCupResult);
  const teams = useSelector(selectTeam);
  useEffect(() => {
    if (dataFetchedRef.current) {
      return;
    }
    dataFetchedRef.current = true;
    dispatch(fetchTeamsAsync());
    dispatch(simWorldCupResultAsync({}));
  });

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div className="App">
        <SimWorldCupHeader />
        {accordion("Group stage", (<WorldCupGroupStage />))}
        {accordion("Knockout stage", (<KnockOutStage />))}
        {accordion("Bracket", <WorldCupBracket />)}
        <Footer />
        <Backdrop open={result.loading || teams.loading}>
          <CircularProgress />
        </Backdrop>
      </div>
    </ThemeProvider>
  );
}

function accordion(summary, details) {
  return <Accordion defaultExpanded={true} TransitionProps={{ unmountOnExit: true }}>
    <AccordionSummary
      expandIcon={<ExpandMore />}
      sx={{ backgroundColor: (theme) => theme.palette.background.default }}
    >
      <Typography fontSize="1.5em" variant="h2">{summary}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ backgroundColor: (theme) => theme.palette.background.default }}>
      {details}
    </AccordionDetails>
  </Accordion>;
}

export default SimWorldCupApp;
